// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"e3-z","colorTextValue":"f3-z","swatches":"g3-z","collapseLink":"h3-z","isCollapsed":"i3-z","dropdown":"j3-z","disabled":"k3-z"};